import { put, select, takeLatest } from 'redux-saga/effects';
import NotificationHandler from 'utils/notification';
import { actions } from '../slices/BusinessPlanSlice';
import { businessPlanApi } from '../../../api';
import ModalHandler from 'utils/modal';
const getSearchCriteria = (state) => state.businessPlan.searchCriteria;

function* getListBusinessPlan({ payload }) {
    try {
        const { getBusinessPlan } = businessPlanApi;
        const { routeName, ...rest } = payload || {};
        const response = yield getBusinessPlan(rest);

        yield put({ type: actions.get_list_succeed.type, payload: response.data });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.get_list_failed.type, payload: error });
    }
}

function* updateBusinessPlan({ payload }) {
    try {
        const { updateBusinessPlan } = businessPlanApi;
        yield updateBusinessPlan(payload);
        yield put({ type: actions.update_business_plan_succeed.type });
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: actions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.fail.type, payload: error });
    }
}

function* importFilelSaga({ payload }) {
    try {
        const { importFile } = businessPlanApi;
        yield importFile(payload);
        yield put({ type: actions.import_file_success.type });
        NotificationHandler.notifySuccess('Import file thành công');
    } catch (error) {
        NotificationHandler.notifyError('Import file không thành công');
        yield put({ type: actions.fail.type, payload: error });
    }
}

function* deleteBusinessPlanlSaga({ payload }) {
    try {
        const { deleteBusinessPlan } = businessPlanApi;
        yield deleteBusinessPlan(payload);
        yield put({ type: actions.delete_business_plan.type });
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: actions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
        NotificationHandler.notifySuccess('Xóa thành công');
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.fail.type, payload: error });
    }
}

function* watchRequestDetail() {
    yield takeLatest(actions.get_list, getListBusinessPlan);
    yield takeLatest(actions.update_business_plan, updateBusinessPlan);
    yield takeLatest(actions.import_file, importFilelSaga);
    yield takeLatest(actions.delete_business_plan, deleteBusinessPlanlSaga);
}

export default watchRequestDetail;
